import { useCallback, useEffect, useState } from 'react';
import API_BASE from '../../utils/api.js';

export function useProducts() {
  const userId = localStorage.getItem('userId');
  const [items, setItems] = useState([]);

  const fetchItems = useCallback(async () => {
    if (!userId) return;

    const res = await fetch(`${API_BASE}/api/products/${encodeURIComponent(userId)}`);
    const data = await res.json();

    const raw = Array.isArray(data) ? data : data.Items || data.items || [];

    const normalized = raw.map((it) => ({
      ...it,
      notes: it.notes ?? it.internalNotes ?? '',
      internalNotes: it.internalNotes ?? it.notes ?? '',
      length: it.length ?? it.dimensions?.length ?? '',
      width: it.width ?? it.dimensions?.width ?? '',
      height: it.height ?? it.dimensions?.height ?? '',
      depth: it.depth ?? it.dimensions?.depth ?? '',
      itemId: it.itemId || it.id,
      vendorName:
        it.vendorName || (it.vendor && typeof it.vendor === 'object' ? it.vendor.name : it.vendor),
      price: it.price ?? it.tradePrice ?? 0,
      isFavorite: Boolean(it.isFavorite),
      createdAt: it.createdAt || null,
    }));

    setItems(normalized);
  }, [userId]);

  const toggleFavorite = async (itemId, isFavorite) => {
    await fetch(`${API_BASE}/api/products/${itemId}/favorite`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, isFavorite }),
    });

    setItems((prev) => prev.map((i) => (i.itemId === itemId ? { ...i, isFavorite } : i)));
  };

  const deleteItem = async (itemId) => {
    if (!userId || !itemId) throw new Error('Missing userId or itemId');

    const res = await fetch(
      `${API_BASE}/api/products/${encodeURIComponent(itemId)}?userId=${encodeURIComponent(userId)}`,
      { method: 'DELETE' }
    );

    if (!res.ok) {
      let message = 'Failed to delete item';
      try {
        const data = await res.json();
        if (data?.error) message = data.error;
      } catch {
        // ignore parse errors
      }
      throw new Error(message);
    }

    setItems((prev) => prev.filter((i) => i.itemId !== itemId));
  };

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  return { items, fetchItems, toggleFavorite, deleteItem };
}
